import { ref, watch, type Ref } from 'vue'

const STORAGE_KEY_PREFIX = 'verdict_hint_shown_'

/**
 * Tracks whether the verdict activation hint has been shown for a given chat session.
 * Once shown, it must not appear again — even across page reloads.
 */
export function useVerdictHintState(sessionUuid: Ref<string | undefined>) {
  const verdictHintShown = ref(false)

  watch(
    sessionUuid,
    (uuid) => {
      verdictHintShown.value =
        !!uuid && localStorage.getItem(`${STORAGE_KEY_PREFIX}${uuid}`) === '1'
    },
    { immediate: true }
  )

  const markVerdictHintShown = () => {
    verdictHintShown.value = true
    if (sessionUuid.value) {
      localStorage.setItem(`${STORAGE_KEY_PREFIX}${sessionUuid.value}`, '1')
    }
  }

  return { verdictHintShown, markVerdictHintShown }
}
